import { Component, ElementRef, inject, input, signal, OnDestroy, OnInit, output, ViewChild } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import dayjs, { DateRange } from '../../utils/dayjs/dayjs';

@Component({
  selector: 'app-date-range',
  imports: [ButtonComponent, ReactiveFormsModule],
  templateUrl: './date-range.component.html',
  styleUrl: './date-range.component.css',
})
export class DateRangeComponent implements OnDestroy, OnInit {
  @ViewChild('container', { static: true }) container!: ElementRef;
  public min = input<string>();
  public max = input<string>();
  public dateRangeChange = output<DateRange>();
  public canceled = output<void>();
  protected isOpen = signal(false);
  protected form!: FormGroup;
  private fb = inject(FormBuilder);

  public ngOnInit() {
    this.form = this.fb.group(
      {
        start: '',
        end: '',
      },
      {
        validators: (group: AbstractControl) => {
          const start = group.get('start')?.value;
          const end = group.get('end')?.value;
          return start && end && !dayjs(start).isAfter(dayjs(end), 'day') ? null : { invalidRange: true };
        },
      },
    );
  }

  public ngOnDestroy() {
    document.removeEventListener('click', this.listener);
  }

  protected close() {
    this.isOpen.set(false);
    document.removeEventListener('click', this.listener);
  }

  protected open() {
    if (this.isOpen()) return;
    this.isOpen.set(true);
    document.addEventListener('click', this.listener);
  }

  protected apply(event: Event) {
    event.stopPropagation();
    const { start, end } = this.form.value;
    this.dateRangeChange.emit({ start: dayjs(start), end: dayjs(end) });
    this.close();
  }

  protected cancel(event: Event) {
    event.stopPropagation();
    this.form.reset();
    this.canceled.emit();
    this.close();
  }

  private listener = (event: Event) => {
    const clickedInside = this.container.nativeElement.contains(event.target as Node);
    if (!clickedInside) {
      this.cancel(event);
    }
  };
}
